import getCharts from '../getCharts'
import { PatientSuperBill } from '../../constants/api.config'

export default async function PatientSuperBillData(mode, type, jsonData, id = '-1', patientID = '-1') {
    try {
        const payload = { mode, type, jsonData, id, patientID }
        const res = await getCharts(PatientSuperBill, payload)
        return res.data
    } catch (error) {
        return error
    }
}
